import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class SettlementDaysForm extends BaseModel {
  settlement_days = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    settlement_days: 'required'
  };

  attributeHints = {
    settlement_days: i18n.t('Please indicate settlement period in number of days')
  };

  attributeLabels = {
    settlement_days: i18n.t('Settlement Days'),
  };
}
